import type { IPartSortByOption } from "@contentful-api/types/contentful";
import type { RefinementListItem } from "instantsearch.js/es/connectors/refinement-list/connectRefinementList";
import type { Dispatch, SetStateAction } from "react";
import { createContext } from "react";

export type FiltersContextAPI = FiltersContextCommonMethods & {
    facets: Facets;
    isMenPage: boolean;
    sortByOptionsList: IPartSortByOption[];
    sizeModalOpen: boolean;
};

export const FiltersContext = createContext<FiltersContextAPI>({
    facets: {},
    setFilterItems: null,
    clearRefinements: null,
    setFiltersDialogOpened: null,
    filtersDialogOpened: false,
    setSortByOptions: null,
    sortByOptions: null,
    isMenPage: false,
    sortByOptionsList: [],
    sizeModalOpen: null,
    setSizeModalOpen: null,
    openFiltersDialog: null,
    closeFiltersDialog: null,
    mobileSortByOpen: false,
    setMobileSortByOpen: null,
    applySelectedRefinementsFromDialog: {},
});

export type FiltersContextCommonMethods = {
    setFilterItems: (items) => void;
    setFiltersDialogOpened: () => void;
    filtersDialogOpened: boolean;
    openFiltersDialog: () => void;
    setSortByOptions: (arg: any) => void;
    sortByOptions: {
        options: any[];
        refine: (refinement: string) => void;
        currentRefinement: string;
    };
    clearRefinements: () => void;
    setSizeModalOpen: Dispatch<SetStateAction<boolean>>;
    closeFiltersDialog: () => void;
    applySelectedRefinementsFromDialog: any;
    mobileSortByOpen: boolean;
    setMobileSortByOpen: Dispatch<SetStateAction<boolean>>;
};

export type Facets = {
    [key: string]: {
        items: RefinementListItem[];
        refine: (value: string) => void;
    };
};
